export default __webpack_public_path__ + "static/media/My-Tools-User-Guide.40dc35e6.pdf";